import React from 'react';

import { Box, Tooltip } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import ProposalStatusIcon from 'common/components/ProposalStatusIcon';
import { getStatusProposalLabel } from 'common/utils/helpers';

const StatusIndicatorTooltip = ({ isGenerated }) => (
    <Tooltip placement="top" title={getStatusProposalLabel(isGenerated)}>
        <Box>
            <ProposalStatusIcon isGenerated={isGenerated} />
        </Box>
    </Tooltip>
);

StatusIndicatorTooltip.propTypes = {
    isGenerated: PropTypes.bool,
};

export default StatusIndicatorTooltip;
